import { Component } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { withStyles } from "@mui/styles";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import PhotoFieldWithPreview from "../Photos/PhotoFieldWithPreview";
import "./SiteMonitoringStructureBloc.css";
import IconButton from "@mui/material/IconButton";
import { blocHasChanged, userIsSiteMonitoringManager } from "../../redux/siteMonitoring/siteMonitoringActions";
import { getCurrentFunctionName } from "../../performanceModeManager";
import { savePlan, deletePlan } from "../../redux/siteMonitoring/planActions";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import { clone } from "../../utils";
import TextFieldWithTypingTimeout from "../Input/TextFieldWithTypingTimeout";
import MarkablePlan from "./MarkablePlan";
import { creatingNote, loadEditingNote } from "../../redux/siteMonitoring/noteActions";

const styles = (theme) => ({
    root: {
        width: "100%",
    },
    heading: {
        fontSize: theme.typography.pxToRem(15),
        flexBasis: "33.33%",
        flexShrink: 0,
    },
    italic: {
        fontSize: theme.typography.pxToRem(13),
        flexBasis: "33.33%",
        flexShrink: 0,
        fontStyle: "italic",
        paddingTop: 0,
    },
    secondaryHeading: {
        fontSize: theme.typography.pxToRem(15),
        color: theme.palette.text.secondary,
    },
    AccordionSummaryContent: {
        content: {
            margin: 3,
        },
    },
});

class SiteMonitoringPlanBloc extends Component {
    constructor(props) {
        super(props);

        this.state = {
            expanded: this.props.expanded === this.props.currentPlanId,
        };
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        let expanded = nextProps.expanded === nextProps.currentPlanId;

        if (prevState.expanded === expanded) return prevState;

        return {
            expanded,
        };
    }

    shouldComponentUpdate(nextProps, nextState) {
        if ((nextProps.expanded === nextProps.currentPlanId) !== this.state.expanded) return true;

        if (this.props.validated !== nextProps.validated) return true;

        if (this.props.currentPlanId !== nextProps.currentPlanId) return true;

        if (!nextState.expanded) return false;

        if (this.props.creationPlan || nextProps.creationPlan) return true;

        let nextBlocValues = nextProps.plan;
        let actualBlocValues = this.props.plan;

        if (!nextBlocValues || !actualBlocValues) {
            console.error("Valeurs introuvables");
            return null;
        }

        try {
            return blocHasChanged(nextBlocValues, actualBlocValues);
        } catch (err) {
            return true;
        }
    }

    validateBloc() {}

    getBlocClasses() {
        let classes = "";

        if (this.props.expanded === this.props.currentPlanId) classes = classes.concat("expanded-bloc");

        return classes;
    }

    getClasses() {
        let classes = "bloc-header without-side-padding";

        if (this.props.expanded === this.props.currentPlanId) classes = classes.concat(" expanded-bloc");

        if (this.props.creationPlan) return classes;

        if (this.props.plan.validated) classes = classes.concat(" ok-bloc");

        return classes;
    }

    deletePlan() {
        this.props.deletePlan(this.props.siteMonitoring, this.props.plan, this.props.activeUser);
    }

    planChange = (value) => {
        let plan = clone(this.props.plan);
        plan.file_id = value;
        this.props.savePlan(this.props.siteMonitoring, plan, this.props.activeUser);
    };

    updatePlanDescription(value) {
        let plan = clone(this.props.plan);
        plan.name = value;
        this.props.savePlan(this.props.siteMonitoring, plan, this.props.activeUser);
    }

    updatePlanAnnotations(annotations) {
        let plan = clone(this.props.plan);
        plan.data = annotations;
        this.props.savePlan(this.props.siteMonitoring, plan, this.props.activeUser);
    }

    creatingAnnotation(annotation) {
        annotation.data = {
            planId: this.props.plan.id,
        };

        this.props.creatingNote(this.props.siteMonitoring, this.props.activeUser, annotation);
    }

    onEditingNote(annotation) {
        this.props.loadEditingNote(annotation.data.noteMobileId);
    }

    onBlocHeaderClick = () => {
        if (this.props.creationPlan) {
            this.props.addPlan();
        } else {
            this.props.onClick(this.props.currentPlanId);
        }
    };

    render() {
        console.perfLog(getCurrentFunctionName());

        const { classes } = this.props;
        let plan = this.props.plan;

        if (!this.props.creationPlan && this.props.expanded) {
            if (!plan) {
                console.error("Valeurs introuvables");
                return null;
            }
        }

        let expandedElement = null;

        if (this.props.expanded !== this.props.currentPlanId)
            expandedElement = (
                <IconButton color="inherit" onClick={this.onBlocHeaderClick.bind(this)} aria-label="Étendre">
                    <ExpandMoreIcon />
                </IconButton>
            );
        else
            expandedElement = (
                <IconButton color="inherit" onClick={this.onBlocHeaderClick.bind(this)} aria-label="Réduire">
                    <ExpandLessIcon />
                </IconButton>
            );

        return (
            <div
                className="col-lg-12 col-md-12 col-sm-12 col-12 without-side-padding"
                ref={(panel) => (this.panel = panel)}
            >
                <Accordion expanded={!this.props.creationPlan && this.state.expanded} className={this.getBlocClasses()}>
                    <AccordionSummary
                        className={this.getClasses()}
                        classes={{ content: classes.AccordionSummaryContent.content }}
                    >
                        {this.props.creationPlan ? (
                            <IconButton
                                className="padding-add-btn"
                                color="inherit"
                                onClick={this.onBlocHeaderClick.bind(this)}
                                disabled={this.props.disabled}
                                aria-label="Ajouter"
                            >
                                <AddIcon />
                            </IconButton>
                        ) : (
                            <div className="row without-side-padding without-margin">
                                <div className="without-side-padding col-lg-2 col-md-2 col-sm-2 col-2">
                                    {expandedElement}
                                </div>
                                <div
                                    className="col-lg-8 col-md-8 col-sm-8 col-8 without-side-padding"
                                    onClick={this.onBlocHeaderClick.bind(this)}
                                >
                                    <Typography className={classes.heading}>{plan.name}</Typography>
                                </div>
                                {!this.props.disabled &&
                                userIsSiteMonitoringManager(this.props.activeUser, this.props.siteMonitoring) ? (
                                    <div className="col-lg-2 col-md-2 col-sm-2 col-2 without-side-padding">
                                        <IconButton
                                            color="inherit"
                                            aria-label="Supprimer"
                                            onClick={this.deletePlan.bind(this)}
                                        >
                                            <DeleteIcon className="red-icon" />
                                        </IconButton>
                                    </div>
                                ) : null}
                            </div>
                        )}
                    </AccordionSummary>
                    {!this.props.creationPlan ? (
                        <AccordionDetails className="site-monitoring-panel-details">
                            <div className="col-lg-12 col-md-12 col-sm-12 col-12 row">
                                <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                                    {plan.file_id ? (
                                        <MarkablePlan
                                            file={plan.file_id}
                                            annotations={plan.data}
                                            planName={plan.name}
                                            updateAnnotations={this.updatePlanAnnotations.bind(this)}
                                            onCreatingAnnotation={this.creatingAnnotation.bind(this)}
                                            currentAnnotationData={this.props.editingNote}
                                            onEditingNote={this.onEditingNote.bind(this)}
                                        />
                                    ) : (
                                        <PhotoFieldWithPreview
                                            acceptPdfAsImage
                                            onPhotoChange={this.planChange.bind(this)}
                                            value={plan.file_id}
                                            disabled={this.props.disabled}
                                            id={"plan-" + this.props.plan.id}
                                            label={"Plan"}
                                        />
                                    )}
                                </div>
                                <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                                    <TextFieldWithTypingTimeout
                                        id={"description-plan-" + this.props.plan.id}
                                        label={"Description"}
                                        className="full_size"
                                        value={this.props.plan.name}
                                        disabled={this.props.disabled}
                                        onValueChange={this.updatePlanDescription.bind(this)}
                                    />
                                </div>
                            </div>
                        </AccordionDetails>
                    ) : null}
                </Accordion>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        siteMonitoring: state.siteMonitoring.currentSiteMonitoring,
        activeUser: state.activeUser,
        expanded: state.siteMonitoring.expandedPlanId,
        editingNote: state.notes.editingNote,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        savePlan: (siteMonitoring, plan, user) => dispatch(savePlan(siteMonitoring, plan, user)),
        deletePlan: (siteMonitoring, plan, user) => dispatch(deletePlan(siteMonitoring, plan, user)),
        creatingNote: (siteMonitoring, user, annotation) => dispatch(creatingNote(siteMonitoring, user, annotation)),
        loadEditingNote: (id) => dispatch(loadEditingNote(id)),
    };
};

export default compose(withStyles(styles), connect(mapStateToProps, mapDispatchToProps))(SiteMonitoringPlanBloc);
